<!--~
~ Copyright (c) 2010-2024 California CAD Solutions, Inc. Licensed subject
~ to an End-User License Agreement included in a separate file named EULA.txt
~ that is distributed with this file.
-->
@if (filterGroupEnabled) {
    <form [formGroup]="filterGroup" class="report-filter-container">
        <mat-expansion-panel class="report-filters mat-elevation-z0"
                             [(expanded)]="filterPanelExpanded"
                             (afterExpand)="populateFilterDefaults()">
            <mat-expansion-panel-header collapsedHeight="32px" expandedHeight="32px">Filters
            </mat-expansion-panel-header>
            <div class="filter-controls-container">
                <div class="filter-row-container">
                    @for (filter of this.definition.filters; track filterTrackByFn(filter)) {
                        <div
                            class="filter-field-container" fxLayout="column" [class.hide-filter]="filter.hidden">
                            <!--<div class="filter-field-name">{{getFilterFieldDisplayName(filter.field)}}:</div>-->
                            @switch (filter.type) {
                                @case ('string') {
                                    <ng-container
                                        *ngTemplateOutlet="stringFilter; context: {filter, dataForm: filterGroup}"></ng-container>
                                }
                                @case ('string-exact') {
                                    <ng-container
                                        *ngTemplateOutlet="stringFilter; context: {filter, dataForm: filterGroup}"></ng-container>
                                }
                                @case ('number') {
                                    <dash-gis-number-range formControlName="filter_{{filter.field}}"
                                                           [label]="getFilterFieldDisplayName(filter.field)"
                                                           [options]="filter.dropdownItems"
                                                           [class.hide-filter]="filter.hidden"></dash-gis-number-range>
                                }
                                @case ('number_dropdown') {
                                    <div fxLayout="row" fxFlex="noshrink">
                                        <mat-form-field class="control-min" [class.hide-filter]="filter.hidden">
                                            <mat-label>{{ getFilterFieldDisplayName(filter.field) }}</mat-label>
                                            <mat-select formControlName="filter_{{filter.field}}_min"
                                                        placeholder="Min"
                                                        aria-label="{{getFilterFieldDisplayName(filter.field)}}">
                                                <mat-option [value]="undefined">-- Select --</mat-option>
                                                @for (opt of filter.dropdownItems; track opt.value) {
                                                    <mat-option
                                                        [value]="opt.value">
                                                        {{ opt.text }}
                                                    </mat-option>
                                                }
                                            </mat-select>
                                        </mat-form-field>
                                        <mat-form-field class="control-max" [class.hide-filter]="filter.hidden">
                                            <mat-label>{{ getFilterFieldDisplayName(filter.field) }}</mat-label>
                                            <mat-select formControlName="filter_{{filter.field}}_max"
                                                        placeholder="Max"
                                                        aria-label="{{getFilterFieldDisplayName(filter.field)}}">
                                                <mat-option [value]="undefined">-- Select --</mat-option>
                                                @for (opt of filter.dropdownItems; track opt.value) {
                                                    <mat-option
                                                        [value]="opt.value">
                                                        {{ opt.text }}
                                                    </mat-option>
                                                }
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                }
                                @case ('date') {
                                    <div fxLayout="row" fxFlex="noshrink">
                                        <dash-gis-date-range formControlName="filter_{{filter.field}}"
                                                             [class.hide-filter]="filter.hidden"
                                                             [label]="getFilterFieldDisplayName(filter.field)"
                                                             [options]="filter.dropdownItems"></dash-gis-date-range>
                                    </div>
                                }
                            }
                        </div>
                    }
                </div>
                <div class="filter-clear-container">
                    <button mat-button type="button" (click)="clearFilters()">Clear Filters</button>
                </div>
            </div>
        </mat-expansion-panel>
    </form>
}

<ng-template #stringFilter let-filter="filter" let-form="dataForm">
    <ng-container [formGroup]="form">
        @if (shouldDisplaySelect(filter)) {
            @if (getDropdownOptions$(filter) | async; as options) {
                <mat-form-field>
                    <mat-label>{{ getFilterFieldDisplayName(filter.field) }}</mat-label>
                    <mat-select formControlName="filter_{{filter.field}}"
                                [multiple]="filter.multi ?? false"
                                aria-label="{{getFilterFieldDisplayName(filter.field)}}">
                        @if (!filter.multi) {
                            <mat-option [value]="undefined">-- Select --</mat-option>
                        }
                        @for (opt of options; track opt.value) {
                            <mat-option
                                [value]="opt.value">
                                {{ opt.text }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            }
        }
        @if (!shouldDisplaySelect(filter)) {
            <mat-form-field class="control-span" [class.hide-filter]="filter.hidden">
                <mat-label>{{ getFilterFieldDisplayName(filter.field) }}</mat-label>
                <input matNativeControl cdkMonitorElementFocus
                       name="filter_{{filter.field}}" type="text"
                       formControlName="filter_{{filter.field}}" />
            </mat-form-field>
        }
    </ng-container>
</ng-template>